// Set the main colors.
const c1 = '#373277';
const c2 = '#4e44d6';
const g1 = '#4CAF50';
const g2 = '#a8e063';
const g3 = '#90d24d';
const c = '#fad000';
const ct2 = '#fac000';
const cinvert = '#fac000';

const theme = {
	main: c2,
	accent: c,
	vr: '1.8',
	c1: c1,
	c2: c2,
	c3: 'rgb(136, 128, 248)',
	p1: '#B362FF',
	cg: '#38367c',
	cg2: '#e2e1f4',
	w: '#f4f4f4',
	white: '#ffffff',
	wt: 'rgba(255,255,255,0.95)',
	c: c,
	cinvert: cinvert,
	ct: 'rgba(250, 208, 0, 0.32)',
	ct2: 'rgba(250, 208, 0, 0.1)',
	black: '#444444',
	black1: '#292929',
	black2: '#3a3a3a',
	g1: g1,
	g2: g2,
	g3: g3,
	gray1: 'rgb(227, 231, 235)',
	gray2: 'rgb(189, 190, 204)',
	gray3: '#737373',
	gray4: 'rgba(189, 190, 204, 0.33)',
	blue2: 'rgba(23, 22, 58, 0.83)',
	blue3: 'rgba(23, 22, 58, 0.33)',
	fh1: "'Alegreya', 'Montserrat', Georgia, sans-serif;",
	f1: "'Alegreya', 'Montserrat', sans-serif;",
	f2: "'Lato',sans-serif;",
	gr1: `linear-gradient(to right, ${c1}, ${c2});`,
	gr2: `linear-gradient(to right, ${c2}, ${c1});`,
	gr3: `linear-gradient(to right, ${g1}, ${g2});`,
	gr4: `linear-gradient(to right, ${g1}, ${g3});`,
	gr5: `linear-gradient(to right, ${c}, ${ct2});`,
	gr6: `linear-gradient(to right, ${g2}, ${g1});`,
	grgreen1: `linear-gradient(to right, ${g1}, ${g2});`,
	grgreen2: `linear-gradient(to right, ${g2}, ${g1});`,
	grgreen3: `linear-gradient(to right, ${g1}, ${g3});`,
	grgreen4: `linear-gradient(to right, ${g3}, ${g2});`,
	grgray1: `linear-gradient(to right,rgb(144,145,157),rgb(189, 190, 204));`,
	grgray2: `linear-gradient(to right,rgb(189, 190, 204),rgb(144,145,157));`,
	grgray3: `linear-gradient(to right,rgb(144,145,157),#acadbb);`,
};

export default theme;
